import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";

const CancelSubscriptionModal = ({ open, onClose, onSubmit, isLoading, organizationName }) => {
  return (
    <Modal isOpen={open} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        <span style={{ fontSize: "18px", fontWeight: "700" }}>
          Cancel Subscription
        </span>
      </ModalHeader>
      <ModalBody>
        <div>
          <h5 style={{ fontWeight: '600', marginBottom: '12px' }}>Are you sure you want to cancel this subscription?</h5>
          <p style={{ color: '#666', fontSize: '14px' }}>
            This will cancel the subscription for <strong>{organizationName || 'this organization'}</strong> and revert them to the free plan.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="danger"
          onClick={onSubmit}
          disabled={isLoading}
        >
          {isLoading ? (
            <Spinner size="sm" color="light" />
          ) : (
            "Yes, Cancel Subscription"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default CancelSubscriptionModal;
